import { observer } from 'mobx-react';
import { autoinject, CardItem, formatDuration, softwareVersionToString, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { ActiveDisplay } from '../ActiveDisplay';

export interface IDisplayGeneralStatsCardProps {
    readonly display: ActiveDisplay;
    readonly loading?: boolean;
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
}

@autoinject
@observer
export class DisplayGeneralStatsCard extends React.Component<IDisplayGeneralStatsCardProps> {
    public render() {
        const { display, statusPoll } = this.props;

        return (
            <StatusCard title="General" loading={this.props.loading}>
                {display.displaySoftware?.mriSoftwareVersion && (
                    <CardItem
                        label="Software Version"
                        value={softwareVersionToString(display.displaySoftware?.mriSoftwareVersion)}
                    />
                )}

                {statusPoll?.videoInputs?.map((v, idx) => {
                    if (!!v.xRes && !!v.yRes)
                        return (
                            <CardItem
                                key={idx}
                                label={v.name ? `${v.name} Resolution` : `Video ${idx + 1} Resolution`}
                                value={
                                    <span>
                                        {v.xRes}x{v.yRes}
                                    </span>
                                }
                            />
                        );
                })}

                {statusPoll?.systemInfo?.nodeInfo?.ipAddr && (
                    <CardItem label="Controller IP Address" value={statusPoll.systemInfo.nodeInfo.ipAddr} />
                )}

                {!!statusPoll?.upTime && <CardItem label="System Run Time" value={formatDuration(statusPoll.upTime)} />}

                {!!statusPoll?.runTimeStatistics?.backlightOn.sincePowerUp && (
                    <CardItem
                        label="Backlight Run Time"
                        value={formatDuration(statusPoll.runTimeStatistics.backlightOn.sincePowerUp)}
                    />
                )}
            </StatusCard>
        );
    }
}
